import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RestService } from '../services/rest.service';
import { Alert } from 'src/app/shared/alert/alert.class';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'account-recovery',
  templateUrl: './account-recovery.component.html',
  styleUrls: ['./account-recovery.component.scss']
})
export class AccountRecoveryComponent implements OnInit {

  user: string;
  password: string;
  confirme_password: string;
  code;

  user_valid = true;
  code_valid = true;
  maskedEmail;
  tokenPassword;
  email: string = "";

  //Contador
  count_min: number = 15;
  count_seg: number = 0;
  intervalo: any;

  flag_error = false;
  error_message;


  view_validate_key = false;
  valid_token = false;

  alert = new Alert();

  view_pass_repet = false;
  view_pass = false;

  @ViewChild('modal_forgot_pass') modal_update: ElementRef;
  @ViewChild('modal_new_setion') modal_new_setion: ElementRef;

  constructor(private titleService: Title, private restService: RestService, private router: Router, private modalService: NgbModal, private route: ActivatedRoute) {
    this.titleService.setTitle("CLARA | Recuperar cuenta");
  }

  ngOnInit() {
    this.user = this.route.snapshot.queryParamMap.get("user");

    this.validate_token();
  }

  //Services Rest ----------------------------------------------------------------------------------------------------------------  

  create_token_password() {

    const data = {
      user: this.user
    }
    this.restService.create_token_password(data).subscribe(
      data => {
        if (data.success) {
          this.tokenPassword = data.tokenPassword;
          this.maskedEmail = data.maskedEmail;
          this.view_validate_key = true;
          this.init_timer();
          this.open_modal_info();

        } else {
          if (data.reason_code == 102) {
            this.flag_error = true;
            this.error_message = "El usuario no existe, verifica e intenta nuevamente."
          }
          else this.alert.set_danger("Algo salio mal, intenta de nuevo.");
          this.user = null;
        }
      },
      error => {
        this.alert.set_danger("Algo salio mal, intenta de nuevo.");
        this.user = null;
      });
  }

  validate_token_password() {
    const data = {
      tokenPassword: this.tokenPassword,
      code: this.code
    }
    this.restService.validate_token_password(data).subscribe(
      data => {
        if (data.success) {
          this.flag_error = false;
          this.alert.set_success("Código validado correctamente.");
          setTimeout(() => {
            this.view_validate_key = false;
            this.valid_token = true
          }, 2000);
        } else {
          this.flag_error = true;
          if (data.reason_code == 107) this.error_message = "Código invalido."
          else if (data.reason_code == 104) {
            this.error_message = "El código ha expirado.";
            this.code_error_go_back();
          } else if (data.reason_code == 105) {
            this.error_message = "El código ya fue usado."
            this.code_error_go_back();
          }
        }
      },
      error => {
        this.alert.set_danger("Algo salio mal, intenta de nuevo.")
        this.code = null;
      });
  }

  change_user_password() {
    const data = {
      tokenPassword: this.tokenPassword,
      user: this.user,
      password: this.password
    }
    this.restService.change_user_password(data).subscribe(
      data => {
        if (data.success) {
          this.alert.set_success("Contraseña actualizada correctamente.");
          setTimeout(() => {
            this.router.navigateByUrl('/signin?user=' + this.user + '&tokenpass=' + this.tokenPassword);
          }, 2000);
        } else {
          this.flag_error = true;
          if (data.reason_code == 107 && data.reason_code == 108) this.error_message = "Usuario y código no coinciden."
          if (data.reason_code == 109) this.error_message = "Intenta de nuevo, contraseña no capturada."
          else if (data.reason_code == 104) {
            this.error_message = "El código ha expirado.";
            this.code_error_go_back();
          } else if (data.reason_code == 105) {
            this.error_message = "El código no fue validado correctamente."
            setTimeout(() => {
              this.view_validate_key = true;
              this.valid_token = false;
              this.flag_error = false;
            }, 2000);
          } else if (data.reason_code == 104) {
            this.error_message = "El tiempo ha expirado.";
            this.code_error_go_back();
          }
        }
      },
      error => {
        this.alert.set_danger("Algo salio mal, intenta de nuevo.")
      });
  }

  //Modals ----------------------------------------------------------------------------------------------------------------  
  open_modal_forgot() {
    this.modalService.open(this.modal_update, { size: 'md' }).result.then((result) => {
      if (result == 'send') {
        this.submit();
      }
      this.email = ""
    }, (reason) => {
      this.email = "";
    });
  }

  open_modal_info() {
    this.modalService.open(this.modal_new_setion, { size: 'md' }).result.then((result) => {
      if (result == 'send') {
        this.submit();
      }
      this.email = ""
    }, (reason) => {
      this.email = "";
    });
  }

  //Other functions ----------------------------------------------------------------------------------------------------------------  
  validate_token() {
    const token = this.restService.getToken();
    if (token) this.router.navigateByUrl('/');
  }

  submit() {
    this.email = "";
    this.alert.set_success("Hemos enviado un mensaje a tu correo");
  }

  back_input_user() {
    this.maskedEmail = null;
    this.code_valid = true;
    this.password = null;
    this.view_validate_key = false;
    this.valid_token = false;
    this.code = null;
  }

  init_timer() {
    this.count_min = 15;
    this.count_seg = 0;

    this.intervalo = setInterval(() => {
      if (this.count_seg === 0) {
        if (this.count_min === 0) {
          clearInterval(this.intervalo);
        } else {
          this.count_min--;
          this.count_seg = 59;
        }
      } else {
        this.count_seg--;
      }
    }, 1000);
  }

  stop_timer() {
    clearInterval(this.intervalo);
  }

  code_error_go_back() {
    setTimeout(() => {
      this.view_validate_key = false;
      this.valid_token = false;
      this.flag_error = false;
    }, 2000);
  }
}
